import script from "./LightGroupsSettingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LightGroupsSettingPage.vue?vue&type=script&setup=true&lang=js"

import "./LightGroupsSettingPage.vue?vue&type=style&index=0&id=d00f4d56&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d00f4d56"]])

export default __exports__